"use client";

import dynamic from "next/dynamic";
import { useMapStore } from "@/lib/stores/mapStore";

const Map = dynamic(() => import("@/components/Stateful/Map/Map"), {
  ssr: false,
});

export default function MapWrapper() {
  const { showMap, geoData, mapBoxApiKey } = useMapStore();

  if (!showMap || !geoData || !mapBoxApiKey) return null;

  return <Map geoData={geoData} mapBoxApiKey={mapBoxApiKey} />;
}
